import { ChangeEvent, useState } from "react";
import { useRoomAddInfContext } from "../context";

export const useSetBaseInf = () => {
  const { koValuesRef, enValuesRef, jaValuesRef } = useRoomAddInfContext();
  const setBasetInf = (langCd: string, formData: any) => {
    if (langCd === "ko") {
      koValuesRef.current = {
        ...(koValuesRef.current || {}),
        ...formData,
      };
    }
    if (langCd === "en") {
      enValuesRef.current = {
        ...(enValuesRef.current || {}),
        ...formData,
      };
    }
    if (langCd === "ja") {
      jaValuesRef.current = {
        ...(jaValuesRef.current || {}),
        ...formData,
      };
    }
  };

  return {
    setBasetInf,
  };
};

export const useEditedLang = () => {
  const { koValuesRef, enValuesRef, jaValuesRef } = useRoomAddInfContext();
  const editedLang = () => {
    let lang = [] as Array<string>;
    const koValue = Object.values(koValuesRef.current || {}).some(
      (value) => value !== "" && value !== null && value !== undefined
    );
    const enValue = Object.values(enValuesRef.current || {}).some(
      (value) => value !== "" && value !== null && value !== undefined
    );
    const jaValue = Object.values(jaValuesRef.current || {}).some(
      (value) => value !== "" && value !== null && value !== undefined
    );

    if (koValue) {
      lang.push("ko");
    }
    if (enValue) {
      lang.push("en");
    }
    if (jaValue) {
      lang.push("ja");
    }

    return lang;
  };

  return {
    editedLang,
  };
};

// 이미지 변경
export const useChangeImg = () => {
  // 이미지 state
  const [imgFile, setImgFile] = useState<File | undefined>(undefined);
  const [preview, setPreview] = useState<string | null>(null);

  // 이미지 업로드
  const onChangeImg = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.currentTarget.files;

    // 이미지 크기 확인
    if (files) {
      const file = files[0];

      if (!file) return;
      if (file) {
        setImgFile(file);
        const imgUrl = URL.createObjectURL(file);
        setPreview(imgUrl);
      }
    }
  };

  return {
    imgFile,
    preview,
    onChangeImg,
  };
};

// 이미지 순번 변경하기
export const useChangeExpsOrdV = () => {
  // 순변
  // 순번 state
  const [ordV, setOrdV] = useState({
    expsOrdV: -1,
    rgSeq: -1,
  });

  const onChangeExpsOrdV = (e: ChangeEvent<HTMLInputElement>) => {
    const { rgseq } = e.currentTarget.dataset;
    setOrdV({
      rgSeq: Number(rgseq),
      expsOrdV: Number(e.currentTarget.value),
    });
  };

  return {
    ordV,
    onChangeExpsOrdV,
  };
};
